import React, { ReactNode } from 'react';

export interface ILinkTextProps {
    onClick: () => void;
    children: ReactNode;
    'data-type'?: string;
}

export const LinkText: React.FC<ILinkTextProps> = ({ onClick, 'data-type': dataType, children }) => {
    return <span data-type={dataType} style={{cursor: 'pointer', color: 'var(--ion-color-primary'}} onClick={onClick}>{children}</span>;
};
